// extracted by mini-css-extract-plugin
module.exports = {"section":"PeopleList-module--section--23pBY","people":"PeopleList-module--people--PKK9g"};